import React from 'react'
import _ from 'lodash'
import { Form, Input, Button, Row, Col, Icon } from 'antd'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { Helmet } from 'react-helmet'

const FormItem = Form.Item

import './Login.scss'

export const Login = ({ getFieldDecorator, loading }) => (
  <Row className="login-row" type="flex" justify="space-around" align="middle">
    <Helmet>
      <title>ลงชื่อเข้าใช้</title>
    </Helmet>
    <Col span="8">
      <Form layout="horizontal" onSubmit={_.noop} className="login-form">
        <img src="images/example.png" />
        <h2 className="logo"><span>logo</span></h2>
        <FormItem>
          {getFieldDecorator('user')(
            <Input prefix={<Icon type="user" style={{ fontSize: 13 }} />} placeholder='admin' />
          )}
        </FormItem>
        <p>
          <Button className="btn-login" type='primary' size="large" icon="poweroff" loading={loading} htmlType='submit'>确定</Button>
        </p>
      </Form>
    </Col>
  </Row>
)

const FormLogin = Form.create()(Login);

function mapStateToProps(state) {
  const {auth} = state;
  if (auth.user) {
    return {user: auth.user, loggingIn: auth.loggingIn, loginErrors: ''};
  }

  return {user: null, loggingIn: auth.loggingIn, loginErrors: auth.loginErrors};
}

const login = _.noop

function mapDispatchToProps(dispatch) {
  return {
    login: bindActionCreators(login, dispatch)
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(FormLogin)



// WEBPACK FOOTER //
// ./src/Login/Login.js